export const gradeTags = [
  {
    id: 1,
    grades: ['K', '1', '2'],
  },
  {
    id: 2,
    grades: ['3', '4'],
  },
  {
    id: 3,
    grades: ['5', '6'],
  },
  {
    id: 4,
    grades: ['6', '7', '8', '9', '10', '11', '12'],
  },
];

export const [beginner, emerging, intermediate, advanced] = gradeTags;

export const gradeTagIds = gradeTags.map((gradeTag) => gradeTag.id);
